import { v4 as uuidv4 } from 'uuid'
import React from 'react'
import { useBlobStorage } from './useBlobStorage'

export function useImageUpload(blobContainerName: string) {
  const { getBlockBlobClient } = useBlobStorage(blobContainerName)
  const [isUploading, setIsUploading] = React.useState<boolean>(false)
  const [progress, setProgress] = React.useState<number>(0)
  const [error, setError] = React.useState<string>('')

  const handleFileUpload = React.useCallback(
    async (file: File) => {
      // file extension to append to the file guid
      setIsUploading(true)
      const fileType = file.name?.split('.')
      const blockBlobClient = await getBlockBlobClient(
        `${uuidv4()}.${fileType[fileType.length - 1]}`
      )

      try {
        const uploadResponse = await blockBlobClient?.uploadData(file, {
          concurrency: 1,
          onProgress: (progressEvent) => {
            if (!file) {
              return
            }
            const newProgress = Math.floor(
              (progressEvent.loadedBytes / file.size) * 100
            )
            setProgress(newProgress)
          },
        })
        setError('')
        const url = uploadResponse?.['_response'].request.url
        return url?.split('?')[0]
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message)
        }
      } finally {
        setIsUploading(false)
        setProgress(0)
      }
    },
    [getBlockBlobClient]
  )

  return {
    handleFileUpload,
    isUploading,
    progress,
    error,
  }
}
